// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Вибрати',
    titleLinkTooltip: 'Перейти на сторінку',
    collapseCardTooltip: 'Згорнути картку',
    expandCardTooltip: 'Розгорнути картку'
  },
  CardList: {
    loadMore: 'Завантажити більше',
    notFound: 'Елементи не знайдено.',
    toolbarSelect: 'Вибрати',
    viewCards: 'Картки',
    viewTiles: 'Плитки',
    viewList: 'Список',
    toolbarView: 'Вигляд'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Вийти',
    cancel: 'Повернутися',
    content: 'Ви впевнені, що хочете закрити це вікно й вийти з нього? Будь-які внесені зміни до даних не збережуться.'
  },
  Cuttable: {
    showMore: 'Показати більше',
    showLess: 'Показати менше'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Скасувати'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Скасувати'
  },
  Dropdown: {
    close: 'Закрити'
  },
  Form: {
    submitButton: 'Зберегти',
    applyButton: 'Застосувати',
    cancelButton: 'Скасувати'
  },
  FormField: {
    clear: 'Очистити',
    remove: 'Видалити',
    addMore: 'Додати ще одне',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Для поліпшення вашого пароля:',
    passwordTooShort: 'Зробіть пароль довшим.',
    lettersLowerCase: 'Використайте щонайменше одну малу літеру.',
    lettersUpperCase: 'Використайте щонайменше одну велику літеру.',
    numbers1: 'Використайте щонайменше одну цифру.',
    numbers3: 'Використайте щонайменше три цифри.',
    specialChar1: 'Використайте щонайменше один спеціальний символ (наприклад: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Використайте щонайменше два спеціальні символи (наприклад: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Використайте як великі, так і малі літери.',
    comboLettersAndNumbers: 'Використайте як цифри, так і літери.',
    comboLettersNumbersSpecial: 'Використайте цифри, літери та спеціальні символи.',
    yourPasswordIsStrong: 'Ви можете зробити свій пароль ще надійнішим, збільшивши його довжину.',
    passwordStrength: 'Надійність пароля: %%strength%%.',
    strengthVeryStrong: 'ДУЖЕ НАДІЙНИЙ',
    strengthStrong: 'НАДІЙНИЙ',
    strengthVeryWeak: 'ДУЖЕ СЛАБКИЙ',
    strengthWeak: 'СЛАБКИЙ',
    strengthMedium: 'СЕРЕДНІЙ',
    hidePassword: 'Приховати пароль',
    showPassword: 'Показати пароль',
    generateButton: 'Згенерувати',
    copyButtonHint: 'Скопіювати пароль',
    copySuccessToast: 'Пароль скопійовано',
    generateButtonHint: 'Згенерувати надійний пароль'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Вилучити зміни',
    editButtonHint: 'Редагувати значення',
    okButtonHint: 'Зберегти зміни'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Вибрати файл...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Загалом елементів: %%totalRows%%',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Вибрано елементів: %%selectedRows%% з %%totalRows%%',
    all: 'Усі',
    allItemsOnPageSelected: 'Вибрано всі елементи на сторінці',
    allItemsSelected: 'Вибрано всі елементи',
    selectAllItems: 'Вибрати всі елементи',
    selectAllItemsOnPage: 'Вибрати всі елементи на сторінці',
    deselectAll: 'Скасувати вибір',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Неможливо знайти елементи, що відповідають фільтру',
    emptyTitle: 'Схоже, тут нічого немає',
    filteredDescription: 'Уточніть запит або видаліть кілька умов із фільтру й спробуйте ще раз.'
  },
  ListOperation: {
    cancelButton: 'Скасувати'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'з %%total%%',
    itemsPerPage: 'Елементів на сторінку',
    all: 'Усі',
    total: 'Сторінка %%current%% з %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Закрити',
    cancelButton: 'Скасувати'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Порожньо',
    placeholder: 'Вибрати...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% з %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Закрити групу'
  },
  Toast: {
    closeButton: 'Close'
  }
};